import { Component, Input } from '@angular/core';

import {
  CellComponent,
  CellContext,
  GridData,
  TextCellConfig,
} from '../../models';

@Component({
  selector: 'app-text-display',
  template: `<span
    [attr.data-testId]="
      'display-' + context.column.header.name + '-' + context.row.index
    "
    >{{
      context.data[context.column.columnDef]
        | truncateText : config?.options?.displayLength
    }}{{
      config?.options?.allowPercentage &&
      !!context.data[context.column.columnDef]
        ? '%'
        : ''
    }}</span
  >`,
  styles: [':host {white-space: pre}'],
})
export class TextDisplayComponent implements CellComponent<GridData> {
  @Input({ required: true }) context!: CellContext<GridData>;

  get config(): TextCellConfig {
    return this.context.config as TextCellConfig;
  }
}
